<template>
    <div class="organization-content">
        <div class="row1">
            <div class="attention-tips">
                <i class="el-icon-s-opportunity"></i>
                {{ $t('addEntityTips') }}
            </div>
            <ImportEntity
                :siteId="getSite.siteId"
                :visible="importEntityModalVisible"
                @on-upload-success="onBatchEntityUploadSuccess"
                @onDialogClose="importEntityModalVisible = false"
            />
            <el-button class="row1-btn wl-green" @click="onImportEntityClick">{{ $t('IMPORT_ENTITY_BUTTON') }}</el-button>
        </div>
        <div class="tree-box">
            <div class="tree-box-inner">
                <el-tree
                    :default-expand-all="true"
                    :expand-on-click-node="false"
                    :data="data"
                    :props="defaultProps"
                    node-key="key"
                    ref="tree"
                    class="kccTree"
                    @node-click="handleNodeClick"
                >
                    <div class="custom-tree-node" slot-scope="{ node, data }">
                        <template>
                            <span v-if="!data.isEdit" :class="`level-${node.level}`">
                                <span v-if="!data.id" class="new-add"></span>
                                <span v-if="data.isChanged" class="is-changed"></span>
                                <i v-if="node.level === 1" class="el-icon-folder-opened"></i>
                                {{ node.label }}
                            </span>
                            <el-input v-else size="small" ref="input" v-model="currentEditEntityName" @blur="submitEdit(node, data)">
                            </el-input>
                        </template>
                        <!-- 操作区 -->
                        <template>
                            <span class="opts">
                                <!-- 组织结构仅有两层，仅第一层和第二层可以添加 -->
                                <el-tooltip :content="`${$t('btn_add')} ${node.level === 1 ? $t('entity') : $t('subEntity')}`" placement="top" :visible-arrow="false" :open-delay="400">
                                    <i v-if="[1, 2].includes(node.level)" class="el-icon-plus" style="color: #1e49e2;" @click="handleAdd(node, data)"></i>
                                </el-tooltip>
                                <!-- 根节点为站点，不可编辑 -->
                                <el-tooltip :content="$t('COMMON_EDIT')" placement="top" :visible-arrow="false" :open-delay="400">
                                    <i v-if="node.level > 1" class="el-icon-edit" style="color: #1e49e2;" @click="handleEdit(node, data)"></i>
                                </el-tooltip>
                                <!-- 上移 -->
                                <el-tooltip :content="$t('TREE_BTN_MOVE_UP')" placement="top" :visible-arrow="false" :open-delay="400">
                                    <i v-if="node.level > 1" class="el-icon-upload2" style="color: #1e49e2;" @click="upNode(node, data)"></i>
                                </el-tooltip>
                                <!-- 下移 -->
                                <el-tooltip :content="$t('TREE_BTN_MOVE_DOWN')" placement="top" :visible-arrow="false" :open-delay="400">
                                    <i v-if="node.level > 1" class="el-icon-download" style="color: #1e49e2;" @click="downNode(node, data)"></i>
                                </el-tooltip>
                                <!-- 根节点为站点，不可删除, 二级实体有子实体才可以删除，三级节点可以删除 -->
                                <el-tooltip :content="$t('COMMON_DELETE')" placement="top" :visible-arrow="false" :open-delay="400">
                                    <i v-if="node.level > 1 && (node.level === 3 || !data.childEntity.length)" class="el-icon-delete" style="color: #ed2124;" @click="handleDelete(node, data)"></i>
                                </el-tooltip>
                            </span>
                        </template>
                    </div>
                </el-tree>
            </div>
        </div>
    </div>
</template>

<script>
import { deleteConfirm, UserInput, loading } from '@/utils'
import API from '@/api'
import bus from '@/components/common/bus'
import { mapGetters } from 'vuex'
import ImportEntity from '../../general-edit/importEntity'

export default {
    components: { ImportEntity },
    data() {
        return {
            siteId: '',
            nodeForm: {
                name: '',
                description: ''
            },
            data: [],
            defaultProps: {
                children: 'childEntity',
                label: 'entityName'
            },
            activeNode: '',
            isRepeat: false,
            initData: {},
            importEntityModalVisible: false,
            currentEditEntityName: '', // 当前编辑的entityName
        }
    },
    computed: {
        rules() {
            const rules = {
                name: [
                    { required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' },
                    {
                        pattern: UserInput.reg3,
                        trigger: 'blur',
                        message: this.$t('ILLEGAL_USER_INPUT_04')
                    }
                ]
            }
            return rules
        },
        ...mapGetters('common', {
            getSite: 'getSite'
        })
    },
    methods: {
        onBatchEntityUploadSuccess() {
            this.importEntityModalVisible = false
            this.$emit('onConfChange', {
                tab: 1,
                key: 'onBatchEntityUploadSuccess',
                value: this.$refs.tree.data[0]
            })
            this.getInitData()
        },
        onImportEntityClick() {
            this.importEntityModalVisible = true
        },
        getInitData() {
            const _loading = loading()
            _loading.load()
          API.general.organizationGeneral({ siteId: this.getSite.siteId }).then(res => {
            if (res.code == '1') {
              this.initData = res.data.clientEntityTree
            } else {
              this.$message.error(this.$t(res.code))
            }
          }).catch(e => {
            console.error(e);
            this.$message.error(this.$t('SYS_USER_003'))
          }).finally(() => {
            _loading.close()
          })
        },
        handleSave() {
            return API.general.saveOrganization({
              siteId: this.getSite.siteId,
              clientEntityTree: this.$refs.tree.data[0]
            }).then(res => {
              if (res.code == '1') {
                this.$message.success(this.$t('msg_save_success'))
              } else {
                this.$message.error(this.$t(res.code))
              }
            }).catch(e => {
                console.error(e);
                this.$message.error(this.$t('SYS_USER_003'))
            }).finally(() => {})
        },
        handleNodeClick(data) {
            this.activeNode = data
        },
        appendSub() {
            if (this.activeNode && this.activeNode.entityType == 'ENTITY') {
                // this.$emit('onConfChange', {
                //     tab: 1,
                //     key: 'appendSub',
                //     value: this.$refs.tree.data[0]
                // })
                this.$refs.tree.append(
                    {
                        id: '',
                        parentKey: this.activeNode.key,
                        key: this.activeNode.key + this.activeNode.childEntity.length,
                        siteId: this.siteId,
                        parentId: this.activeNode.id,
                        entityName: '',
                        entityDesc: '',
                        isEdit: true,
                        seq: '',
                        entityType: 'SUB_ENTITY',
                        childEntity: []
                    },
                    this.activeNode
                )
            } else {
                this.$message.error(this.$t('TREE_BTN_ADD_ERROR'))
            }
        },
        appendEntity() {
            // this.$emit('onConfChange', {
            //     tab: 1,
            //     key: 'appendEntity',
            //     value: this.$refs.tree.data[0]
            // })
            this.$refs.tree.append(
                {
                    id: '',
                    parentKey: this.$refs.tree.data[0].key,
                    key: this.$refs.tree.data[0].key + this.$refs.tree.data[0].childEntity.length,
                    siteId: this.siteId,
                    parentId: this.$refs.tree.data[0].id,
                    entityName: '',
                    entityDesc: '',
                    isEdit: true,
                    seq: '',
                    entityType: 'ENTITY',
                    childEntity: []
                },
                this.$refs.tree.data[0]
            )
        },

        deleteNode() {
            if (!this.activeNode) {
                this.$message.error(this.$t('ENTITY_NODE_SELECT'))
            } else if (this.activeNode.entityType == 'ROOT') {
                this.$message.error(this.$t('ENTITY_ROOT_DELETE'))
            } else if (this.activeNode.childEntity && this.activeNode.childEntity.length > 0) {
                this.$message.error(this.$t('ENTITY_HAVECHILD_DELETE'))
            } else if (this.activeNode.id === '') {
                // 删除新增未保存的节点
                deleteConfirm().then(() => {
                    this.$emit('onConfChange', {
                        tab: 1,
                        key: 'deleteNode',
                        value: this.$refs.tree.data[0]
                    })
                    this.$refs.tree.remove(this.activeNode)
                    this.$refs.nodeForm.resetFields()
                })
            } else {
                deleteConfirm().then(() => {
                    if (this.activeNode.id) {
                        API.general.checkAssociated({ entityId: this.activeNode.id }).then((res) => {
                            if (res.code == 'CANNOT_DELETE_ENTITY' && res.errDetails.msg) {
                                this.$message.error(this.$t(res.errDetails.msg))
                            } else if (res.code == '1' && !res.data) {
                                this.$emit('onConfChange', {
                                    tab: 1,
                                    key: 'deleteNode',
                                    value: this.$refs.tree.data[0]
                                })
                                this.$refs.tree.remove(this.activeNode)
                            } else {
                                this.$message.error(this.$t(res.code))
                            }
                        })
                    }
                })
            }
        },
        upNode(node, data) {
            this.activeNode = data
            const pNodes = this.$refs.tree.getNode(this.activeNode.parentKey).childNodes
            const index = pNodes.findIndex((item) => item.key == this.activeNode.key)
            this.$emit('onConfChange', {
                tab: 1,
                key: 'upNode',
                value: this.$refs.tree.data[0]
            })
            if (index == 0) {
                this.$message.warning(this.$t('TREE_BTN_MOVE_UP_ERROR'))
            } else {
                this.$refs.tree.remove(this.activeNode)
                this.$refs.tree.insertBefore(this.activeNode, pNodes[index - 1])
            }
        },
        downNode(node, data) {
            this.activeNode = data
            const pNodes = this.$refs.tree.getNode(this.activeNode.parentKey)
            const index = pNodes.childNodes.findIndex((item) => item.key == this.activeNode.key)
            this.$emit('onConfChange', {
                tab: 1,
                key: 'downNode',
                value: this.$refs.tree.data[0]
            })
            if (index == pNodes.childNodes.length - 1) {
                this.$message.warning(this.$t('TREE_BTN_MOVE_DOWN_ERROR'))
            } else if (index == pNodes.childNodes.length - 2) {
                this.$refs.tree.remove(this.activeNode)
                this.$refs.tree.append(this.activeNode, pNodes)
            } else {
                this.$refs.tree.remove(this.activeNode)
                this.$refs.tree.insertAfter(this.activeNode, pNodes.childNodes[index])
            }
        },
        // 失去焦点，保存验证
        submitEdit(node, data) {
            if (data.entityName === this.currentEditEntityName) {
                // 没有修改
                this.currentEditEntityName = ''
                this.$set(data, 'isEdit', false)
                this.$set(data, 'isChanged', false)
            } else {
                this.$set(data, 'entityName', this.currentEditEntityName)
                this.currentEditEntityName = ''
                this.$set(data, 'isEdit', false)
                if (data.id) {
                    this.$set(data, 'isChanged', true)
                }
                this.$emit('onConfChange', {
                    tab: 1,
                    key: 'edit',
                    value: this.$refs.tree.data[0]
                })
            }
            // 新增的节点(没有id)，当输入框没有文字时，失去焦点删除此条
            if (data.entityName.trim() === '') {
                if (!data.id) {
                    this.$refs.tree.remove(data)
                } else {
                    this.$set(data, 'isEdit', true)
                    this.$message.warning(this.$t('ENTITY_003'))
                    this.$nextTick(() => {
                        this.$refs.input.focus()
                    })
                }
            }
        },
        handleEdit(node, data) {
            this.currentEditEntityName = data.entityName
            if (data.isEdit) return
            this.$set(data, 'isEdit', true)
            this.$nextTick(() => {
                this.$refs.input.focus()
            })
        },
        handleDelete(node, data) {
            deleteConfirm().then(() => {
                if (data.id) {
                    API.general.checkAssociated({ entityId: data.id }).then((res) => {
                        if (res.code == 'CANNOT_DELETE_ENTITY' && res.errDetails.msg) {
                            this.$message.error(this.$t(res.errDetails.msg))
                        } else if (res.code == '1' && !res.data) {
                            this.$emit('onConfChange', {
                                tab: 1,
                                key: 'deleteNode',
                                value: this.$refs.tree.data[0]
                            })
                            this.$refs.tree.remove(data)
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    })
                } else {
                    // 删除新增未保存的节点
                    deleteConfirm().then(() => {
                        this.$emit('onConfChange', {
                            tab: 1,
                            key: 'deleteNode',
                            value: this.$refs.tree.data[0]
                        })
                        this.$refs.tree.remove(data)
                    })
                }
            })
        },
        handleAdd(node, data) {
            // 添加实体
            if (node.level === 1) {
                this.appendEntity()
            } else if (node.level === 2) {
                this.activeNode = data
                this.appendSub()
            }
            this.$nextTick(() => {
                this.$refs.input.focus()
            })
        },
    },
    watch: {
        initData: {
            handler: function (val, oldval) {
                if (val) {
                    this.siteId = this.initData.siteId
                    this.data = [val]
                }
            }
        }
    },
    mounted() {
      this.getInitData()
    },
    created() {
        bus.$on('clientName', (msg) => {
            this.data[0].entityName = msg
        })
    }
}
</script>
<style scoped>
.organization-content {
    display: flex;
    flex-direction: column;
    height: 100%;
}
.row1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
  flex-shrink: 0;
}

.row1 .attention-tips {
    color: #fd349c;
    padding-left: 20px;
}

.row1 .row1-btn {
  margin-right: 10px;
}

.tree-box {
    width: 100%;
    height: 100%;
    overflow-y: auto;
}

.tree-box-inner {
    width: 500px;
    height: 100%;
    padding-left: 15px;
}

::v-deep.kccTree.el-tree .el-tree-node__label {
    font-size: 14px;
}

::v-deep .el-tree-node__content {
    height: 32px !important;
}

.custom-tree-node {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 10px;
    font-size: 13px;
}

.custom-tree-node .level-1 {
    font-weight: bolder;
    font-size: 14px;
}
.custom-tree-node .level-1 i {
    color: #1e49e2;
    font-size: 16px;
}
.custom-tree-node .level-2 {
    font-weight: bolder;
}

.custom-tree-node .opts {
    display: inline-flex;
    justify-content: flex-end;
    align-items: center;
    width: 160px;
    height: 100%;
    flex-shrink: 0;
    visibility: hidden;
}

.el-tree-node__content:hover .custom-tree-node {
    color: #1e49e2;
}
.el-tree-node__content:hover .custom-tree-node .opts {
    visibility: visible;
}
.custom-tree-node .opts i {
    cursor: pointer;
    margin-left: 10px;
}

.custom-tree-node .new-add {
    display: inline-block;
    width: 2px;
    height: 100%;
    background-color: #67C23A;
}
.custom-tree-node .is-changed {
    display: inline-block;
    width: 2px;
    height: 100%;
    background-color: #E6A23C;
}

</style>
